import { CompaniesApi, CompanyResponse } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export interface ICompanyService {
  getAll(): Promise<CompanyResponse[]>
}

export class CompanyService implements ICompanyService {
  private readonly client = createApiClient(CompaniesApi)

  async getAll(): Promise<CompanyResponse[]> {
    const { data } = await this.client.getCompanies()
    return data
  }
}

export const companyService: ICompanyService = new CompanyService()
